// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__16IJq","file":"styles_file__2Vstu"};